<template>
  <div id="main">
    <split-pane :min-percent="10" :default-percent="20" split="vertical">
      <template slot="paneL">
        <div id="bumTreeDiv">
          <OrgTree ref="orgTree" :parentMsg="parentMsg" v-on:treeInfo="getTreeInfo"></OrgTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div class="rightTopBar">
            <div class="rightTopLeft">
              <div style="display: flex;">
                <div>
                  <span style="font-size: 13px;">姓名</span>
                  <el-input
                    style="margin-top: 10px;"
                    placeholder="请输入"
                    v-model="filterName"
                    class="input-with-select"
                    size="small"
                    clearable
                  >
                  </el-input>
                </div>
                <div style="margin-left: 10px;">
                  <span style="font-size: 13px;">手机号</span>
                  <el-input
                    style="margin-top: 10px;"
                    placeholder="请输入"
                    v-model="filterPhone"
                    minlength="11"
                    maxlength="11"
                    class="input-with-select"
                    onkeyup="value=value.replace(/[^\d]/g,'');if(value<0)value=null"
                    size="small"
                    clearable
                  >
                  </el-input>
                </div>
                <div style="display:flex;align-items: end;margin-left: 15px;">
                  <el-button size="small" type="primary" @click="inputSearch" plain>查询</el-button>
                  <el-button size="small" @click="reSetSearch" plain>重置</el-button>
                </div>
              </div>
            </div>
            <div class="rightInputKey">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-refresh"
                @click="showChangeOrg"
                plain
              >移动人员</el-button>
              <el-button size="small" type="primary" icon="el-icon-plus" @click="addForm" plain>新增人员</el-button>
              <!--              <el-button-->
              <!--                size="small"-->
              <!--                type="primary"-->
              <!--                icon="el-icon-user-solid"-->
              <!--                @click="showRoleAssignments"-->
              <!--                plain-->
              <!--              >角色分配</el-button>-->
              <!--              <el-button-->
              <!--                size="small"-->
              <!--                type="primary"-->
              <!--                icon="el-icon-share"-->
              <!--                @click="relationBtn(1)"-->
              <!--                plain-->
              <!--              >关联组织项目</el-button>-->
              <!--              <el-button-->
              <!--                size="small"-->
              <!--                type="primary"-->
              <!--                icon="el-icon-s-promotion"-->
              <!--                @click="ssoDistribute()"-->
              <!--                plain-->
              <!--              >分发</el-button>-->
              <!--              <el-button-->
              <!--                size="small"-->
              <!--                type="primary"-->
              <!--                icon="el-icon-plus"-->
              <!--                @click="addUser()"-->
              <!--                plain-->
              <!--              >导入人员</el-button>-->
            </div>
          </div>
          <div class="bumRightContent">
            <div class="table">
              <el-table
                :data="tableData"
                border
                stripe
                size="small"
                highlight-current-row
                :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                style="width: 100%"
                height="100%"
                @selection-change="handleSelectionChange"
                @row-click="handleRowClick"
                ref="multipleTable"
              >
                <el-table-column type="selection" :selectable="selectable" width="40"></el-table-column>
                <!--
                                    <el-table-column prop="userId" align="left" header-align="center" :show-overflow-tooltip='true' label="用户名id">
                                    </el-table-column>
                -->
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  fixed="left"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  align="left"
                  width="120"
                  fixed="left"
                  header-align="center"
                  :show-overflow-tooltip="true"
                  label="员工姓名"
                ></el-table-column>
                <el-table-column
                  prop="jobName"
                  align="left"
                  width="200"
                  header-align="center"
                  :show-overflow-tooltip="true"
                  label="岗位"
                ></el-table-column>
                <el-table-column
                  prop="positionName"
                  align="left"
                  width="200"
                  header-align="center"
                  :show-overflow-tooltip="true"
                  label="职务"
                ></el-table-column>
                <el-table-column
                  prop="seniority"
                  width="70"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="岗龄(年)"
                ></el-table-column>
                <el-table-column
                  prop="sex"
                  width="80"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="性别"
                >
                  <template slot-scope="scope">
                    <span>{{scope.row.sex==1?'男':'女'}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="familyName"
                  align="left"
                  width="150"
                  header-align="center"
                  :show-overflow-tooltip="true"
                  label="民族"
                ></el-table-column>
                <el-table-column
                  prop="politicalStatusName"
                  width="150"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="政治面貌"
                ></el-table-column>
                <el-table-column
                  prop="educationName"
                  width="150"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="学历"
                ></el-table-column>
                <el-table-column
                  prop="phone"
                  width="150"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="联系方式"
                ></el-table-column>
                <el-table-column
                  prop="createUserName"
                  width="150"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="创建人"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  width="150"
                  align="center"
                  :show-overflow-tooltip="true"
                  label="创建时间"
                ></el-table-column>
                <el-table-column align="center" label="状态" width="170">
                  <template slot-scope="scope">
                    <el-radio-group
                      v-model="scope.row.status"
                      @change="statusChange($event, scope.row)"
                      size="mini"
                    >
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="2">停用</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="220">
                  <template slot-scope="scope">
                    <el-tooltip content="重置密码" placement="top">
                      <el-button
                        size="mini"
                        icon="el-icon-key"
                        @click="showResetPwd(scope.row)"
                        circle
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="角色分配" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-user-solid"
                        @click="showSingleRoleAssignments(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
<!--                    <el-tooltip content="关联组织项目" placement="top">-->
<!--                      <el-button-->
<!--                        size="mini"-->
<!--                        type="primary"-->
<!--                        icon="el-icon-share"-->
<!--                        @click="relationBtn(scope.row)"-->
<!--                        circle-->
<!--                        plain-->
<!--                      ></el-button>-->
<!--                    </el-tooltip>-->
                    <el-tooltip content="复制" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-copy-document"
                        @click="addForms(scope.row)"
                      circle
                        plain
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="编辑" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-edit"
                        @click="editForm(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除" placement="top">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        @click="showDelAlert(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[15, 30, 50, 100]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totle"
              ></el-pagination>
            </div>
          </div>
        </div>

        <el-dialog
          title="关联组织项目"
          top="7vh"
          :close-on-click-modal="false"
          :visible.sync="dialogRelVisible"
          class="relTree-wrap"
        >
          <el-container>
            <el-header>
              <el-input
                placeholder="请输入项目名称查询"
                v-model="filterText"
                class="input-with-select"
                size="small"
                clearable
              >
                <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
              </el-input>
            </el-header>
            <el-main style="max-height:500px">
              <el-tree
              v-loading="org_tree_loading"
            element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                class="filter-tree"
                :data="enumData"
                :props="props"
                node-key="id"
                highlight-current
                :check-on-click-node="true"
                :default-checked-keys="defaultCheckedKeys"
                :filter-node-method="filterNode"
                :default-expanded-keys="defaultExpandedKeys"
                ref="relTree"
                show-checkbox
                :check-strictly="true"
              ></el-tree>
            </el-main>
          </el-container>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmRel" size="medium">确 定</el-button>
            <el-button @click="dialogRelVisible = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="新增人员"
          top="7vh"
          :close-on-click-modal="false"
          :visible.sync="dialogAddFormVisible"
        >
          <el-form :model="form" :rules="rules" ref="form">
            <el-row>
              <el-col :span="12">
                <el-form-item label="用户名" :label-width="formLabelWidth" prop="userName">
                  <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">
                  <el-input type="number" v-model="form.orderNo" placeholder="请输入排序号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工姓名" :label-width="formLabelWidth" prop="name">
                  <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="岗位" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'idm_post')" filterable multiple clearable style="width: 100%;" v-model="form.jobCode" placeholder="请选择岗位">
                    <el-option
                      v-for="item in postData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职务" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'idm_job')" multiple clearable style="width: 100%;" v-model="form.position" placeholder="请选择职务">
                    <el-option
                      v-for="item in positionData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="岗龄(年)" :label-width="formLabelWidth" prop="seniority">
                  <el-input v-model="form.seniority" onkeyup="value = value.replace(/[^\d.]/g,'')" oninput="if(value>99){value=value.substring(0, 2)}"
                            placeholder="请输入岗龄"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" :label-width="formLabelWidth" prop="certNo">
                  <el-input @blur="IdCardBlur" v-model="form.certNo" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别:" :label-width="formLabelWidth" prop="sex">
                  <el-radio-group v-model="form.sex" size="mini">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="民族" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'DM_MZDM')" style="width: 100%;" v-model="form.familyCode" placeholder="请选择民族">
                    <el-option
                      v-for="item in familyData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="政治面貌" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'POLIT_OUTLOOK')" style="width: 100%;" v-model="form.politicalStatusCode" placeholder="请选择政治面貌">
                    <el-option
                      v-for="item in politicalStatusData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="学历" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'education')" style="width: 100%;" v-model="form.educationCode" placeholder="请选择学历">
                    <el-option
                      v-for="item in educationData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参加工作时间" :label-width="formLabelWidth" prop="birthday">
                  <el-date-picker
                    type="date"
                    placeholder="请选择参加工作时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="form.startWorkDate"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="进入公司时间" :label-width="formLabelWidth" prop="birthday">
                  <el-date-picker
                    type="date"
                    placeholder="请选择进入公司时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="form.joinDate"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
                  <el-select @change="selectChange($event,'idm_person_type')" style="width: 100%;" v-model="form.userTypeCode" placeholder="请选择类型">
                    <el-option
                      v-for="item in personTypeData"
                      :key="item.dm"
                      :label="item.name"
                      :value="item.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用工形式" :label-width="formLabelWidth" prop="orderNo">
                  <el-input :disabled="form.userTypeCode == 1" v-model="form.employmentTypeName" :placeholder="form.userTypeCode==1?'请输入用工形式':'请输入承包商名称'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" :label-width="formLabelWidth" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birthday">
                  <el-date-picker
                    type="date"
                    placeholder="选择出生日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="form.birthday"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveForm('form')" size="medium">确 定</el-button>
            <el-button @click="dialogAddFormVisible = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>



        <el-dialog
          title="移动人员"
          top="10vh"
          :close-on-click-modal="false"
          :visible.sync="dialogChangeOrgVisible"
        >
          <el-form :model="org">
            <el-form-item label="选择组织" :label-width="formLabelWidth">
              <SelectTree
                :props="defaultProps"
                :options="orgTreeData"
                :value="org.id"
                :clearable="true"
                :accordion="true"
                placeholder="请选择组织"
                style="width: 80%;"
                @getValue="getValue($event)"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="changeOrg" size="medium">确 定</el-button>
            <el-button @click="dialogChangeOrgVisible = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>
         <!-- <el-dialog
          title="复制人员到其他组织"
          top="10vh"
          :close-on-click-modal="false"
          :visible.sync="dialogChangeOrgVisibles"
        >
          <el-form :model="org">
            <el-form-item label="选择组织" :label-width="formLabelWidth">
              <SelectTree
                :props="defaultProps"
                :options="orgTreeData"
                :value="org.id"
                :clearable="true"
                :accordion="true"
                placeholder="请选择组织"
                style="width: 80%;"
                @getValue="getValue($event)"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="changeOrgs" size="medium">确 定</el-button>
            <el-button @click="dialogChangeOrgVisibles= false" size="medium">取 消</el-button>
          </div>
        </el-dialog> -->
           <el-dialog
          title="复制组织到其他项目"
          top="7vh"
          :close-on-click-modal="false"
          :visible.sync="dialogChangeOrgVisibles"
          class="relTree-wrap"
        >
          <el-container>
            <el-header>
              <el-input
                placeholder="请输入项目名称查询"
                v-model="filterText"
                class="input-with-select"
                size="small"
                clearable
              >
                <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
              </el-input>
            </el-header>
            <el-main>
              <el-tree
              v-loading="org_tree_loading"
            element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                class="filter-tree"
                :data="enumDatas"
                :props="props"
                node-key="id"
                highlight-current
                :check-on-click-node="true"
                :default-checked-keys="defaultCheckedKeyss"
                :filter-node-method="filterNode"
               :default-expanded-keys="defaultExpandedKeys"
                ref="relTree"
                show-checkbox
                :check-strictly="true"
              ></el-tree>
            </el-main>
          </el-container>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="changeOrgs" size="medium">确 定</el-button>
            <el-button @click="dialogChangeOrgVisibles = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>
        <div class="bumDialogDiv">
          <el-dialog
            title="岗位分配"
            top="7vh"
            :close-on-click-modal="false"
            :visible.sync="dialogRoleVisible"
          >
            <div style="display: flex;">
              <div style="width: 50%;">
                <div style="padding-bottom: 10px;margin-left: 10px">待选岗位</div>
                <RolesTree :key="newDataTimeLeft" ref="leftTreeShow" :parentMsg="rolesTreeMsg" @getCheckedKeys="getRoles"></RolesTree>
              </div>
              <div style="border-right: 1px solid #d9d9d9;margin: 0 20px"></div>
              <div style="width: 50%">
                <div style="display: flex;justify-content: space-between;align-items: center;padding-bottom: 10px;">
                  <div style="margin-left: 10px">已选岗位</div>
                  <div @click="open" style="margin-right: 10px;cursor: pointer;color: #409EFF">重新选择</div>
                </div>
                <RolesTree :key="newDataTimeRight" ref="rightTreeShow" :filter="true" :parentMsg="rolesTreeMsg" @getCheckedKeys="getRoles"></RolesTree>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
<!--              <el-button type="primary" @click="dialogRoleVisible = false" size="small">确 定</el-button>-->
              <el-button  @click="dialogRoleVisible = false" size="small">关 闭</el-button>
            </div>
          </el-dialog>
          <el-dialog
            title="修改人员信息"
            top="5vh"
            :close-on-click-modal="false"
            :visible.sync="dialogEditFormVisible"
          >
            <el-form :model="form" :rules="rules" ref="form">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="用户名" :label-width="formLabelWidth" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">
                    <el-input type="number" v-model="form.orderNo" placeholder="请输入排序号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="员工姓名" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="岗位" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'idm_post')" filterable multiple clearable style="width: 100%;" v-model="form.jobCode" placeholder="请选择岗位">
                      <el-option
                        v-for="item in postData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职务" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'idm_job')" multiple clearable style="width: 100%;" v-model="form.position" placeholder="请选择职务">
                      <el-option
                        v-for="item in positionData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="岗龄(年)" :label-width="formLabelWidth" prop="seniority">
                    <el-input v-model="form.seniority" onkeyup="value = value.replace(/[^\d.]/g,'')" oninput="if(value>99){value=value.substring(0, 2)}"
                              placeholder="请输入岗龄"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号" :label-width="formLabelWidth" prop="certNo">
                    <el-input @blur="IdCardBlur" v-model="form.certNo" placeholder="请输入身份证号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性别:" :label-width="formLabelWidth" prop="sex">
                    <el-radio-group v-model="form.sex" size="mini">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="民族" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'DM_MZDM')" style="width: 100%;" v-model="form.familyCode" placeholder="请选择民族">
                      <el-option
                        v-for="item in familyData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="政治面貌" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'POLIT_OUTLOOK')" style="width: 100%;" v-model="form.politicalStatusCode" placeholder="请选择政治面貌">
                      <el-option
                        v-for="item in politicalStatusData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="学历" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'education')" style="width: 100%;" v-model="form.educationCode" placeholder="请选择学历">
                      <el-option
                        v-for="item in educationData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="参加工作时间" :label-width="formLabelWidth" prop="birthday">
                    <el-date-picker
                      type="date"
                      placeholder="请选择参加工作时间"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      v-model="form.startWorkDate"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="进入公司时间" :label-width="formLabelWidth" prop="birthday">
                    <el-date-picker
                      type="date"
                      placeholder="请选择进入公司时间"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      v-model="form.joinDate"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
                    <el-select @change="selectChange($event,'idm_person_type')" style="width: 100%;" v-model="form.userTypeCode" placeholder="请选择类型">
                      <el-option
                        v-for="item in personTypeData"
                        :key="item.dm"
                        :label="item.name"
                        :value="item.dm"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="用工形式" :label-width="formLabelWidth" prop="orderNo">
                    <el-input :disabled="form.userTypeCode == 1" v-model="form.employmentTypeName" :placeholder="form.userTypeCode==1?'请输入用工形式':'请输入承包商名称'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系方式" :label-width="formLabelWidth" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birthday">
                    <el-date-picker
                      type="date"
                      placeholder="选择出生日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      v-model="form.birthday"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveForm('form')" size="medium">确 定</el-button>
              <el-button @click="dialogEditFormVisible = false" size="medium">取 消</el-button>
            </div>
          </el-dialog>

          <el-dialog
             width="600px"
            :visible="dialogVisible"
            class="custom"
            custom-class="custom-class"
            @close="dialogVisible=false"
          >
            <span slot="title" class="dialog-title">
              <div class="title-left">选择分发服务器</div>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveSelect()">确 定</el-button>
              <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
            <div>
              <el-table
                @selection-change="handleServeSelectionChange"
                :data="severData"
                ref="thisTable"
                size="small"
                fit
                :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                style="width:100%;"
                border
              >
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="value" label="服务器名称" header-align="center" align="center"></el-table-column>
                <!-- <el-table-column
                  prop="key"
                  label="编码"
                  width="60"
                  header-align="center"
                  align="center"
                ></el-table-column> -->
              </el-table>
            </div>
          </el-dialog>
          <!-- 选人加入 -->
          <el-dialog
          title="人员"
          top="10vh"
          :close-on-click-modal="false"
          :visible.sync="userVisible"
        >
        <div style="height:60vh">
          <orgPeopleComponents2
          :baseUrl="'/api'"
      :query="dataQuery"
      :data="data"
      :filterOrgId="'-1'"
      :self="1"
      :selectWay="'mult'"
      @selectArr="selectUser"
          ref="orgPeopleComponents"
        ></orgPeopleComponents2>
        </div>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveUserMethd()" size="medium">确 定</el-button>
            <el-button @click="userVisible = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>
        </div>
      </template>
    </split-pane>
  </div>
</template>

<script>
import OrgTree from "@/components/OrgTree";
import FDRolesTree from "@/components/FDRolesTree";
import SelectTree from "@/components/FDTreeSelect";
import {
  distributeUser,
  getSeverData,
  getUserList,
  deleteUser,
  resetPassword,
  setStatus,
  addOrUpdateUser,
  changeOrgByUsers,
  getTyList,
  UsersToRoles,
  deleteImg,
  UsersToRolesForOne,
  relOrg,
  getProByUserId,
  addUser
} from "../api/baseUser";
import { getAdmOrgTree } from "../api/admOrg";
import { getProOrgTree } from "../api/proOrg";
import md5 from 'js-md5';
export default {
  components: {
    OrgTree: OrgTree,
    RolesTree: FDRolesTree,
    SelectTree: SelectTree
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      if(!/^[\d]+$/.test(value)){
        return callback(new Error('请输入数字！'))
      }
      setTimeout(() => {
        if ((""+value).length > 11) {
          callback(new Error('长度不能超过11！'));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkNum2 = (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      if(!/^[\d]+$/.test(value)){
        return callback(new Error('请输入数字！'))
      }
      setTimeout(() => {
        if ((""+value).length > 20) {
          callback(new Error('长度不能超过20！'));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkNumAndWord= (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      if(!/^[\d\w]+$/.test(value)){
        return callback(new Error('请输入数字或字母！'))
      }
      setTimeout(() => {
        if ((""+value).length <= 15 || (""+value).length >= 20) {
          callback(new Error('长度不能少于15！不能超过18！'));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      data:[],
      dataQuery:{
        person:true,  //是否选人
        department:false,  //是否选组织
      },
      userVisible:false,
      rowss:{},
      selectArr: [],
      dialogVisible: false,
      severData: [],
      orgId: "",
      newFormFlag: true,
      filterName: "",
      filterPhone:'',
      keyword: "",
      rolesTreeMsg: {},
      parentMsg: {
        enumTitle: "人员管理",
        refreshTreeFlag: false
      },
      treeInfo: Object,
      dialogRoleVisible: false,
      dialogAddFormVisible: false,

      dialogEditFormVisible: false,
      dialogChangeOrgVisible: false,
      dialogChangeOrgVisibles:false,
      formLabelWidth: "100px",
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      imageUrl4: "",
      totle: 0,
      rows: 15,
      currentPage: 1,
      tableData: [],
      selectRoles: [],
      multipleSelection: [],
      orgTreeData: [],
      defaultProps: {
        value: "id",
        children: "children",
        isLeaf: "leaf",
        checked: "false",
        label: "label"
      },
      org: {
        id: ""
      },
      options: [],
      familyData:[],
      politicalStatusData:[],
      educationData:[],
      personTypeData:[],
      positionData:[],
      postData:[],
      form: {
        userTypeCode:'1',
        sex:1,
        employmentTypeName:''
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符之间",
            trigger: "blur"
          }
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符之间",
            trigger: "blur"
          }
        ],
        position: [
          {
            min: 0,
            max: 30,
            message: "长度不得超过 30 个字符",
            trigger: "blur"
          }
        ],
        phone: [
          { validator: checkNum, trigger: 'blur' },
        ],
        eMail: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        qq: [
          { validator: checkNum, trigger: 'blur' }
        ],
        bank: [
          { validator: checkNum2, trigger: 'blur' }
        ],
        birthplace: [
          {
            min: 0,
            max: 30,
            message: "长度不得超过 30 个字符",
            trigger: "blur"
          }
        ],
        certNo: [
          { validator: checkNumAndWord, trigger: 'blur' }
        ]
      },
      dialogRelVisible: false,
      filterText: "",
      enumData: [],
       enumDatas: [],
      org_tree_loading: false,
      props: {
        children: "children",
        label: "label"
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys:[],
      defaultCheckedKeyss: [],
      newDataTimeRight:'',
      newDataTimeLeft:'',
      privacyFieldOpt:[
        {name:'电话',id:'phone'},
        {name:'身份证号',id:'certNo'},
        {name:'银行卡号',id:'bank'},
      ],
      selectUserArr:[]
    };
  },
  watch: {
    treeInfo: function(newVal, oldVal) {
      this.currentPage = 1;
      this.orgId = newVal.listenParentId;
      this.getTableData(newVal.listenParentId);
    }
  },
  computed: {},
  methods: {
    reSetSearch(){
      this.filterName = ''
      this.filterPhone = ''
      this.inputSearch()
    },
    IdCardBlur(val){
      var value = this.form.certNo
      if(value && value.length>=17){
        if((value.substr(16,1))%2){
          this.form.sex = 1
        }else{
          this.form.sex = 2
        }
      }
    },
    selectChange(val,type){
      var temp = null
      if(type == 'DM_MZDM'){//民族
        temp = this.familyData.find(it=>it.dm == val)
        this.form.familyName = temp?temp.name:''
      }else if(type == 'POLIT_OUTLOOK'){//政治面貌
        temp = this.politicalStatusData.find(it=>it.dm == val)
        this.form.politicalStatusName = temp?temp.name:''
      }else if(type == 'education'){//学历
        temp = this.educationData.find(it=>it.dm == val)
        this.form.educationName = temp?temp.name:''
      }else if(type == 'idm_person_type'){//类型
        temp = this.personTypeData.find(it=>it.dm == val)
        this.form.userTypeName = temp?temp.name:''
        if(val == 1){//企业员工
          this.form.employmentTypeName = '滇中在册（滇中企业员工）'
        }else{
          this.form.employmentTypeName = ''
        }
      }else if(type == 'idm_job'){
        temp = this.positionData.find(it=>it.dm == val)
        this.form.positionName = temp?temp.name:''
      }else if(type =='idm_post'){
        temp = this.postData.find(it=>it.dm == val)
        this.form.jobName = temp?temp.name:''
      }
    },
    getFamilyData(code){
      this.$axios.get(`/api/dsp/api/dm/element/list/code/${code}?t=${new Date().getTime()}`).then((res)=>{
        if(res.data.success){
          if(code =='DM_MZDM'){
            this.familyData=res.data.rows
          }else if(code == 'POLIT_OUTLOOK'){
            this.politicalStatusData = res.data.rows
          }else if(code =='education'){
            this.educationData = res.data.rows
          }else if(code == 'idm_person_type'){
            this.personTypeData = res.data.rows
            if(this.personTypeData.length>0&&!this.form.userId){
              this.form.userTypeCode = this.personTypeData[0].dm
              this.form.employmentTypeName = '滇中在册（滇中企业员工）'
            }
          }else if(code=='idm_job'){
            this.positionData = res.data.rows
          }else if(code=='idm_post'){
            this.postData = res.data.rows
          }
        }else{
          if(code =='DM_MZDM'){
            this.familyData = []
          }else if(code == 'POLIT_OUTLOOK'){
            this.politicalStatusData = []
          }else if(code =='education'){
            this.educationData = res.data.rows
          }else if(code == 'idm_person_type'){
            this.personTypeData = []
          }else if(code=='idm_job'){
            this.positionData = []
          }else if(code=='idm_post'){
            this.postData = []
          }
        }
      })
    },
    saveUserMethd(){
      let query={
        orgId:this.orgId,
        userList:this.selectUserArr
      }
      addUser(query).then(res=>{
        if(res.succeed){
          this.$message.success("添加成功")
          this.userVisible=false
          this.handleCurrentChange(1)

        }

      })

    },
    selectUser(data){
      console.log("eeerr",data)
      this.selectUserArr=data

    },
    addUser(){
      if (this.orgId === "" || this.orgId === "-1") {
        this.$message({
          type: "warning",
          message: "请先选择相应组织!"
        });
        return;
      }
      this.userVisible=true

    },
    handleServeSelectionChange(val) {
      this.selectArr = val;
    },
    saveSelect() {
      if (this.selectArr.length === 0) {
        this.$message({
          type: "warning",
          message: "请先选择相应服务器!"
        });
        return;
      }

      var userIds = [];
      for (var index in this.multipleSelection) {
        userIds.push(this.multipleSelection[index].userId);
      }
      var serverCodes = this.selectArr.map(item => {
        return item.key;
      });

      distributeUser(
        this.$qs.stringify({
          userId: userIds.join(','),
          serverCode: serverCodes.join(',')
        })
      ).then(response => {
        if (response.succeed) {
          this.dialogVisible = false;
          this.$message({
            type: "success",
            message: "人员分发成功!"
          });
        } else {
          this.$message({
            message: response.msg,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    open() {
      this.$confirm('此操作将清空已选角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getRoles([])
        this.$message({
          type: 'success',
          message: '清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        });
      });
    },
    getRoles(roles,filter) {
      console.log(roles,filter);
      this.selectRoles = roles;
      this.usersToRoles(filter)
    },
    getValue(value) {
      this.org.id = value;
    },
    inputSearch() {
      this.keyword = this.filterName;
      this.handleCurrentChange(1);
    },
    handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData(this.orgId);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData(this.orgId);
    },
    showSingleRoleAssignments(data) {
      this.multipleSelection = [data];
      this.showRoleAssignments();
    },
    showRoleAssignments() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "warning",
          message: "请先勾选相应人员!"
        });
        return;
      }

      this.rolesTreeMsg = {
        refreshTreeFlag: true,
        self: 1,
        async: 0,
        showCheckBox: true,
        onlyLeaf: false,
        isSingle: this.multipleSelection.length === 1,
        singleUserId: this.multipleSelection[0].userId
      };
      this.dialogRoleVisible = true;
    },
    ssoDistribute: function() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "warning",
          message: "请先勾选相应人员!"
        });
        return;
      }
      this.dialogVisible = true;
    },
    getTreeInfo: function(data) {
      this.treeInfo = data;
    },
    getTableData: function(orgId) {
      var params = {
        orgId: orgId === "-1" ? "" : orgId,
        name: this.keyword,
        page: this.currentPage,
        rows: this.rows
      };
      if(this.filterPhone){
        params.phone = this.filterPhone
      }
      getUserList(this.$qs.stringify(params))
        .then(response => {
          this.totle = response.total;
          if (response.rows != null && response.rows.length > 0) {
            response.rows.forEach((val)=>{
              val.userNameMd5=md5(val.userName).substr(9,16);
            })
            this.tableData = response.rows;
          } else {
            this.tableData = [];
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    getServerList() {
      getSeverData()
        .then(response => {
          this.totle = response.total;
          if (response.data != null) {
            this.severData = [];
            for (const key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                this.severData.push({ key: key, value: response.data[key] });
              }
            }
          } else {
            this.tableData = [];
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    addForm: function() {
      this.form =  {
        userTypeCode:'1',
        sex:1,
        employmentTypeName:''
      }
      if (this.orgId === "" || this.orgId === "-1") {
        this.$message({
          type: "warning",
          message: "请先选择相应组织!"
        });
        return;
      }
      this.getFamilyData('DM_MZDM')//民族
      this.getFamilyData('POLIT_OUTLOOK')//政治面貌
      this.getFamilyData('education')//学历
      this.getFamilyData('idm_person_type')//类型
      this.getFamilyData('idm_job')//职务
      this.getFamilyData('idm_post')//岗位
      // this.form = { orgId: this.orgId, sex: 1 };
      this.form.orgId = this.orgId
      this.form.sex = 1
      this.newFormFlag = true;
      this.dialogAddFormVisible = true;
    },
    addForms(row) {

      this.rowss.name=row.name
      // this.rowss.userId=row.userId
      this.rowss.userName=row.userName
      this.rowss.position=row.position
      this.rowss.phone=row.phone
      this.rowss.eMail=row.eMail
 this.rowss.bank=row.bank
 this.rowss.certNo=row.certNo
 this.rowss.birthplace=row.birthplace
 this.rowss.orderNo=row.orderNo
 this.rowss.birthday=row.birthday
 this.rowss.master=0

      this.rowss.sex=row.sex
     this.rowss.qq=row.qq
      this.dialogChangeOrgVisibles = true;

      let len = this.multipleSelection.length;
      if (typeof row === "object") {
        this.$refs.multipleTable.clearSelection();
        this.getRelByUserIds(row.userName);
         console.log (row.userName,1230)
        this.multipleSelection = [row];
      } else {
        if (len === 0) {
          this.$message.warning("请选择要关联的用户");
          return;
        }
        this.defaultCheckedKeyss= [];
      }

      this.filterText = "";
      this.dialogChangeOrgVisibles = true;
      this.getTemplateTrees("new");

    },
     getTemplateTrees (data) {
        getAdmOrgTree(this.$qs.stringify({async:0})).then(response => {
          let mainTree = {id:'-1', label:'安责险信息管理综合服务平台'}
          if (response.length <= 0) {
            this.enumDatas = [mainTree]
            this.$emit('treeInfo', { 'listenParentId': '-1', 'listenParentName': '暂无' })
          } else {
            mainTree.children = response
            let temp = [mainTree]

            // 展开至第一级
              this.defaultExpandedKeys = [temp[0].id]
              if (temp[0].children !== null && temp[0].children.length > 0) {
                // 展开至第二级
                for (var i = 0; i < temp[0].children.length; i++) {
                  this.defaultExpandedKeys.push(temp[0].children[i].id)
                }
            }
            this.enumDatas = temp
            if (data !== 'refresh') {
              this.$emit('treeInfo', { 'listenParentId': temp[0].id, 'listenParentName': temp[0].label })
            }
            if (this.parentMsg.expandId !== undefined && this.parentMsg.expandId !== null && this.parentMsg.expandId !== '') {
              this.defaultExpandedKeys = [this.parentMsg.expandId]
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.parentMsg.expandId)
              })
            }
          }
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      // fuzhi
     changeOrgs() {
       let nodeCheck = this.$refs.relTree.getCheckedKeys();
        this.rowss.orgId=nodeCheck.join(",")
        console.log(this.rowss.orgId,410)
      // if (nodeCheck==0 ){
      //   this.$message({
      //     type: "warning",
      //     message: "请先选择组织!"
      //   });
      //   return;
      // }else{
        // for(let s in nodeCheck){
        // this.rowss.orgId =nodeCheck[s]

      addOrUpdateUser(this.newFormFlag, this.$qs.stringify(this.rowss)).then(
            response => {
              console.log(response,4120)

      })

      this.dialogChangeOrgVisibles = false

     },
    editForm: function(form) {
      console.log(document.cookie);
      this.form = Object.assign({},form);
      this.$set(this.form,'privacyField',!!form.privacyField?form.privacyField.split(','):[])
      console.log("this.form")
      // this.form.privacyField=!!form.privacyField?form.privacyField.split(','):[]
      this.newFormFlag = false;
      this.imageUrl1 = `/api/baseUser/getImg?userId=${
        this.form.userId
      }&imgType=1&tempid=${Math.random()}`;
      this.imageUrl2 = `/api/baseUser/getImg?userId=${
        this.form.userId
      }&imgType=2&tempid=${Math.random()}`;
      this.imageUrl3 = `/api/baseUser/getImg?userId=${
        this.form.userId
      }&imgType=3&tempid=${Math.random()}`;
      this.imageUrl4 = `/api/baseUser/getImg?userId=${
        this.form.userId
      }&imgType=4&tempid=${Math.random()}`;

      this.getFamilyData('DM_MZDM')//民族
      this.getFamilyData('POLIT_OUTLOOK')//政治面貌
      this.getFamilyData('education')//学历
      this.getFamilyData('idm_person_type')//类型
      this.getFamilyData('idm_job')//职务
      this.getFamilyData('idm_post')//岗位
      if(this.form.jobCode&&this.form.jobCode.indexOf(',')!=-1){
        this.form.jobCode = this.form.jobCode.split(',')
      }else{
        this.form.jobCode = [this.form.jobCode]
      }

      if(this.form.position&&this.form.position.indexOf(',')!=-1){
        this.form.position = this.form.position.split(',')
      }else{
        this.form.position = [this.form.position]
      }
      this.dialogEditFormVisible = true;
    },
    saveForm: function(form) {
      if(this.form.jobCode&&Array.isArray(this.form.jobCode)){
        var jobNames = []
        this.form.jobCode.forEach(it=>{
          var temp = this.postData.find(ix=>it == ix.dm)
          if(temp){
            jobNames.push(temp.name)
          }
        })
        this.form.jobName = jobNames.join(',')
        this.form.jobCode = this.form.jobCode.join(',')
      }
      if(this.form.position&&Array.isArray(this.form.position)){
        var positionNames = []
        this.form.position.forEach(it=>{
          var temp = this.positionData.find(ix=>it == ix.dm)
          if(temp){
            positionNames.push(temp.name)
          }
        })
        this.form.positionName = positionNames.join(',')
        this.form.position = this.form.position.join(',')
      }

      this.form.master=1;
      this.$refs[form].validate(valid => {
        if (valid) {
          if(!!this.form.id){
            this.form.privacyField=this.form.privacyField.join(',')
          }

          addOrUpdateUser(this.newFormFlag, this.$qs.stringify(this.form)).then(
            response => {
              if (response.succeed) {
                this.$message.success("保存成功")
                this.dialogAddFormVisible = false;
                this.dialogEditFormVisible = false;
                this.getTableData(this.treeInfo.listenParentId);
                this.parentMsg = {
                  enumTitle: "组织管理",
                  refreshTreeFlag: true,
                  expandId: this.treeInfo.listenParentId
                };
              } else {
                this.$message({
                  message: response.msg,
                  showClose: true,
                  type: "error"
                });
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    showDelAlert: function(data) {
      this.$confirm(
        "此操作将永久删除该人员 " + data.name + ", 是否继续?",
        "提示",
        {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.delForm(data);
      });
    },
    delForm: function(data) {
      deleteUser(this.$qs.stringify({ userId: data.userId })).then(response => {
        if (response.succeed) {
          this.getTableData(this.treeInfo.listenParentId);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            message: response.msg,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    statusChange: function(status, data) {
      setStatus(
        this.$qs.stringify({ userId: data.userId, status: status })
      ).then(response => {
        this.getTableData(this.treeInfo.listenParentId);
        if (response.succeed) {
          this.$message({
            type: "success",
            message: "状态修改成功!"
          });
        } else {
          this.$message({
            message: response.msg,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    showResetPwd: function(data) {
      this.$confirm("此操作将重置 " + data.name + " 密码, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.resetPwd(data);
      });
    },
    resetPwd: function(data) {
      resetPassword(this.$qs.stringify({ userId: data.userId })).then(
        response => {
          if (response.succeed) {
            this.$message({
              type: "success",
              message: "密码重置成功!"
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: "error"
            });
          }
        }
      );
    },
    usersToRoles(data) {
      if (!!data) {
        this.newDataTimeLeft = new Date().getTime()
      } else  {
        this.newDataTimeRight = new Date().getTime()
      }
      var userIds = [];
      for (var index in this.multipleSelection) {
        userIds.push(this.multipleSelection[index].userId);
      }

      if (this.rolesTreeMsg.isSingle) {
        UsersToRolesForOne(
          this.$qs.stringify({
            jsonRoleId: JSON.stringify(this.selectRoles),
            jsonUserId: this.rolesTreeMsg.singleUserId
          })
        ).then(response => {
          if (response.succeed) {
            this.getTableData(this.treeInfo.listenParentId);
            this.dialogRoleVisible = true;
            this.$message({
              type: "success",
              message: "角色分配成功!"
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: "error"
            });
          }
        });
      } else {
        UsersToRoles(
          this.$qs.stringify({
            jsonRoleId: JSON.stringify(this.selectRoles),
            jsonUserId: JSON.stringify(userIds)
          })
        ).then(response => {
          if (response.succeed) {
            this.getTableData(this.treeInfo.listenParentId);
            this.dialogRoleVisible = true;
            this.$message({
              type: "success",
              message: "角色分配成功!"
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: "error"
            });
          }
        });
      }
    },
    showChangeOrg() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请先选择相应人员!"
        });
        return;
      }
      this.org.id = "";
      this.dialogChangeOrgVisible = true;
    },// 反选
getRelByUserIds(userId){
  this.$axios.post(`/api/baseUser/getOrgListByCode?userCode=${userId}&master=${0}`).then((res)=>{

    if(res.data.data.length>0){
      this.defaultCheckedKeyss=res.data.data.map(item=>item.orgId)

    }
    else{
      this.defaultCheckedKeyss=[]
    }
  })
},


    getRelByUserId(userId) {
      getProByUserId(userId)
        .then(res => {
          // console.log(res)
          if (res.data.length > 0) {
            this.defaultCheckedKeys = res.data.map(item => item.ORG_ID);
          } else {
            this.defaultCheckedKeys = [];
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    relationBtn(row) {
      let len = this.multipleSelection.length;
      if (typeof row === "object") {
        this.$refs.multipleTable.clearSelection();
        this.getRelByUserId(row.userId);
        this.multipleSelection = [row];
      } else {
        if (len === 0) {
          this.$message.warning("请选择要关联的用户");
          return;
        }
        this.defaultCheckedKeys = [];
      }
      this.filterText = "";
      this.dialogRelVisible = true;
      this.getTemplateTree("new");
    },
    confirmRel() {
      //确定关联
      let nodeCheck = this.$refs.relTree.getCheckedKeys();
      console.log(nodeCheck,11000);
      // if(nodeCheck.length === 0) {
      //     this.$message.warning("请选择组织项目")
      //     return
      // }
      console.log(this.multipleSelection);
      let multipleSelection = this.multipleSelection.map(item => item.userId);

      let params = {
        userId: multipleSelection.join(","),
        proId: nodeCheck.join(",")
      };

      relOrg(params.userId, params.proId)
        .then(res => {
          console.log(res);
          if (res.succeed) {
            this.$message.success("保存成功");
            this.multipleSelection = [];
            this.$refs.multipleTable.clearSelection();
          } else {
            this.$message.error(res.msg);
          }
          this.dialogRelVisible = false;
        })
        .catch(err => {
          this.dialogRelVisible = false;
          this.$message.error(err);
        });
    },
    treeFilter() {
      this.$refs.relTree.filter(this.filterText);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getTemplateTree(data) {
      this.org_tree_loading=true;
      getProOrgTree(this.$qs.stringify({ async: 0 }))
        .then(response => {
          let mainTree = { id: "-1", label: "组织项目" };
          if (response.length <= 0) {
            this.enumData = [mainTree];
          } else {
            mainTree.children = response;
            let temp = [mainTree];

            // 展开至第一级
            this.defaultExpandedKeys = [temp[0].id];
            this.enumData = temp;
          }
          this.org_tree_loading=false;
        })
        .catch(error => {
          this.org_tree_loading=false;
          console.log("error:" + error.toString());
        });
    },
    changeOrg() {
      if (this.org.id === null || this.org.id === "") {
        this.$message({
          type: "warning",
          message: "请先选择组织!"
        });
        return;
      }

      var userIds = [];
      for (var index in this.multipleSelection) {
        userIds.push(this.multipleSelection[index].userId);
      }
      changeOrgByUsers(
        this.$qs.stringify({
          orgId: this.org.id,
          userIds: JSON.stringify(userIds)
        })
      ).then(response => {
        if (response.succeed) {
          this.getTableData(this.treeInfo.listenParentId);
          this.dialogChangeOrgVisible = false;
          this.$message({
            type: "success",
            message: "移动人员成功!"
          });
        } else {
          this.$message({
            message: response.msg,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    getOrgTree() {
      getAdmOrgTree(this.$qs.stringify({ async: 0 }))
        .then(response => {
          if (response.length > 0) {
            this.orgTreeData = response;
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    selectable(row, index) {
      return row.status === 1;
    },
    handleAvatarSuccess1(res, file) {
      this.imageUrl1 = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess2(res, file) {
      this.imageUrl2 = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess3(res, file) {
      this.imageUrl3 = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess4(res, file) {
      this.imageUrl4 = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isImage =
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/gif";

      if (!isImage) {
        this.$message.error("上传图片只能是png、jpg、jpeg、gif格式!");
      }

      return true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getTypeList() {
      getTyList()
        .then(response => {
          console.log(response,"response")
          this.options = response.data;
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    handleRowClick(row) {
      if (this.treeInfo.listenParentId !== row.orgId) {
        this.$refs.orgTree.selectOrg(row.orgId, row.orgName)
      }
    }
  },
  mounted() {

    console.log(document.cookie);
    this.getTableData();
    this.getOrgTree();
    this.getTypeList();
    this.getServerList();
      this.getTemplateTrees("new");
  }
};
</script>

<style scoped lang="less">
#main {
  height: 100%;
}
/deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4] {
  background-color: #e6eef8;
  width: 1px;
  margin-left: 5px;
  border-left: none;
  border-right: none;
}
/deep/ .splitter-pane-resizer[data-v-212fa2a4] {
  opacity: initial;
}
#bumTreeDiv {
  width: 95%;
  height: 95%;
  height: -webkit-calc(100% - 10px);
  height: calc(100% - 10px);
  float: left;
  background: white;
  margin-right: 5px;
  padding-left: 10px;
  padding-top: 10px;
}

#listTables {
  width: calc(100% - 20px);
  float: right;
  background: white;
  height: calc(100% - 10px);
  padding: 10px 10px 0;
}

#rightName {
  float: left;
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
  margin-top: 15px;
}

.rightTopButton {
  text-align: left;
  margin-left: 10px;
  margin-bottom: 10px;
}

.bumRightContent {
  height: 92.5%;
  height: -webkit-calc(100% - 60px - 30px);
  height: calc(100% - 60px - 30px);
  background: white;
  overflow: auto;
  padding: 0 10px 32px;
  box-sizing: border-box;
}

.pagination {
  height: 44px;
  margin: 0px 0 -32px;
  background: #ecf5ff;
  text-align: left;
}

.table {
  height: calc(100% - 12px);
  background: #d9c666;
}

.rightTopBar {
  padding-left: 10px;
  padding-right: 10px;
  height: 75px;
  flex: 1;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}

.rightInputKey {
  //width: 300px;
  height: calc(100% - 15px;);
  display: flex;
  align-items: end;
  padding-bottom: 15px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.bumDialogDiv .el-dialog__body {
  padding: 0px 20px 0px;
}

.bumDialogDiv .el-dialog__footer {
  padding: 0px 20px 20px;
}
.relTree-wrap {
  .el-dialog__body {
    height: 60vh;
    overflow: auto;
  }
  .el-header {
    height: auto !important;
    margin-bottom: 10px;
  }
  .el-header,
  .el-main {
    padding: 0;
  }
}

/deep/.el-button--primary{
  background-color:#4873C0 !important;
  border-color:#4873C0 !important;
  color: white !important;
}

/deep/.filter-tree{
  height: auto !important;
}
/deep/.vue-splitter-container{
  height: calc(100% - 3px) !important;
}
/deep/.splitter-pane-resizer{
  //display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/BaseUserManage.vue